<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-row no-gutters>
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="showUpload = true"><v-icon>upload</v-icon></v-btn>
            </template>
            <span>Upload Kontoauszug</span>
          </v-tooltip>
          Kontobuch {{ konto }}
        </v-col>
        <v-col cols="6" class="text-center">
          <v-btn icon @click="monat = new Date(monat.setMonth(monat.getMonth() - 1))"
            ><v-icon>keyboard_arrow_left</v-icon></v-btn
          >
          <v-btn text @click="monat = new Date()">{{ $filters.date(monat, "MM.YYYY") }}</v-btn>
          <v-btn icon @click="monat = new Date(monat.setMonth(monat.getMonth() + 1))"
            ><v-icon>keyboard_arrow_right</v-icon></v-btn
          >
        </v-col>
        <v-col cols="3" class="text-right">
          <v-btn small outlined @click="showAnleitung = true">Anleitung</v-btn>
          <!-- <v-toolbar-items>
            <v-text-field
              v-model='search'
              append-icon='search'
              label='Suchen'
              single-line
              solo
              flat
              hide-details
              clearable
              clear-icon="close"
            ></v-text-field>
          </v-toolbar-items> -->
        </v-col>
      </v-row>
      <v-chip small label color="green" dark>BETA</v-chip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="ma-0">
      <v-col cols="8">
        <v-card outlined>
          <v-data-table
            ref="rechnungenTabelle"
            dense
            height="calc(100vh - 270px)"
            :headers="headers"
            :items="kontobuch.buchungen"
            :search="search"
            fixed-header
            :items-per-page="-1"
            :hide-default-header="$vuetify.breakpoint.xsOnly"
            no-data-text="Für diesen Monat wurden bisher keine Buchungen hochgeladen."
            hide-default-footer
          >
            <template v-slot:header="{ item }">
              <tr class="hidden-sm-and-up">
                <th></th>
                <th>Nummer</th>
                <th>Bundesbruder</th>
                <th>Betrag</th>
                <th>Status</th>
              </tr>
            </template>
            <template v-slot:item="{ item }">
              <tr
                v-on:click="(selectedEintrag = item) && buchungClick()"
                :class="item.Abgeschlossen ? 'green lighten-4' : 'trasparent'"
              >
                <td width="130px">{{ $filters.date(item.Buchungstag.seconds * 1000, "DD.MM.YYYY") }}</td>
                <td>{{ item.Verwendungszweck }}</td>
                <td>{{ item["Beguenstigter/Zahlungspflichtiger"] }}</td>
                <td>{{ item.Betrag | money }}</td>
                <td v-if="item.Betrag > 0 && item.file">
                  <v-btn icon class="green--text"><v-icon>cloud_done</v-icon></v-btn>
                </td>
                <td v-if="item.Betrag > 0 && !item.file">
                  <v-btn icon class="green--text"><v-icon>cloud_upload</v-icon></v-btn>
                </td>
                <td v-if="item.Betrag < 0 && item.file">
                  <v-btn icon class="green--text"><v-icon>cloud_done</v-icon></v-btn>
                </td>
                <td v-if="item.Betrag < 0 && !item.file">
                  <v-btn icon class="red--text"><v-icon>cloud_upload</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <v-card outlined class="text-right pa-2 my-2"> Summe: {{ kontobuch.summe | money }} </v-card>
        <span class="caption"
          >{{ kontobuch.buchungen.length }} Buchungen | Hochgeladen am
          {{ $filters.date(kontobuch.geaendertAm, "DD.MM.YYYY") }}</span
        >
      </v-col>
      <v-col cols="4">
        <!-- {{ selectedEintrag }} -->
        <v-card outlined>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td width="140px">Verwendungszweck:</td>
                <td>{{ selectedEintrag.Verwendungszweck }}</td>
              </tr>
              <tr>
                <td width="140px">Begünstigter:</td>
                <td>{{ selectedEintrag["Beguenstigter/Zahlungspflichtiger"] }}</td>
              </tr>
              <tr>
                <td width="140px">Buchtungsdatum:</td>
                <td>{{ $filters.date(selectedEintrag.Buchungstag.seconds * 1000, "DD.MM.YYYY") }}</td>
              </tr>
              <tr>
                <td width="140px">Betrag:</td>
                <td>{{ selectedEintrag.Betrag | money }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-card-text>
            <v-btn v-if="selectRechnung" outlined block @click="showRechnung = true"
              ><v-icon>launch</v-icon> Rechnung {{ selectRechnung.rechnungsnummer }}</v-btn
            >
            <v-btn v-else block outlined>Keine passende Rechnung gefunden</v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" class="mb-1"
                ><v-text-field
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  v-model="selectedEintrag.Betreff"
                  label="Betreff/Veranstaltung"
                ></v-text-field
              ></v-col>
              <v-col cols="12" class="mb-1"
                ><v-autocomplete
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  :items="artItems"
                  v-model="selectedEintrag.Art"
                  label="Art"
                ></v-autocomplete
              ></v-col>
              <v-col cols="6" class="mb-1 pr-1"
                ><v-text-field
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  v-model="selectedEintrag.Betrag1"
                  label="Betrag"
                ></v-text-field
              ></v-col>
              <v-col cols="6" class="mb-1"
                ><v-text-field
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  v-model="selectedEintrag.Betrag2"
                  label="2. Betrag"
                ></v-text-field
              ></v-col>
              <v-col cols="6" class="mb-1 pr-1"
                ><v-select
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  :items="['Keine Angabe', '19%', '7%']"
                  v-model="selectedEintrag.MwSt1"
                  label="MwSt-Satz"
                ></v-select
              ></v-col>
              <v-col cols="6" class="mb-1"
                ><v-select
                  class="mb-2"
                  outlined
                  dense
                  hide-details
                  :items="['Keine Angabe', '19%', '7%']"
                  v-model="selectedEintrag.MwSt2"
                  label="2. MwSt-Satz"
                ></v-select
              ></v-col>
              <v-col cols="12" class="mb-1"
                ><v-textarea
                  class="mb-2"
                  rows="3"
                  outlined
                  dense
                  hide-details
                  v-model="selectedEintrag.Bemerkung"
                  label="Bemerkung"
                ></v-textarea
              ></v-col>
              <v-col cols="12" class="mb-1">
                <v-file-input outlined hide-details dense label="Rechnung hochladen" v-model="file"></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          {{ this.selectedEintrag.file }}
          <v-divider></v-divider>
          <v-card-text class="text-right">
            <v-btn @click="setAbgeschlossen()" class="primary">Speichern</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showUpload" width="50%" persistent>
      <v-card>
        <v-card-title> Bank Daten hochladen </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="warning" class="mt-2">
            Achtung: Monat erst hochladen wenn alle Buchungen vorhanden sind. Ein nachträgliches Hinzufügen oder
            Entfernen von Buchungen der Liste ist nicht möglich.
          </v-alert>
          <v-file-input
            accept=".csv"
            prepend-icon="attach_file"
            label="CSV-Datei zum importieren auswählen"
            v-model="csvDatei"
          ></v-file-input>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="showUpload = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="uploadData()">hochladen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showImport" width="80%" scrollable persistent>
      <v-card>
        <v-card-title> Daten importieren ({{ eintrage.length }}) </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-simple-table dense fixed-header>
            <thead>
              <tr>
                <th>Buchungstag</th>
                <th>Person</th>
                <th>Verwendungszweck</th>
                <th>Betrag</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in eintrage" :key="index">
                <td>{{ $filters.date(item.Buchungstag, "DD.MM.YYYY") }}</td>
                <td>{{ item["Beguenstigter/Zahlungspflichtiger"] }}</td>
                <td>{{ item.Verwendungszweck }}</td>
                <td class="text-right">{{ item.Betrag | money }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="showImport = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="importData">Importieren</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAnleitung" width="50%" scrollable persistent>
      <v-card>
        <v-card-title> Anleitung Kontobuch </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table dense fixed-header>
            <tbody>
              <tr>
                <td>1.</td>
                <td>
                  Exportiere die Buchungsübersicht der Sparkasse als CSV-Datei. Achte auf Vollständigkeit des Monats
                </td>
              </tr>
              <tr>
                <td>2.</td>
                <td>
                  Lade die Datei in dieser Ansicht hoch. Dabei werden Buchungen die nicht in den Monat gehören
                  automatisch entfernt.
                </td>
              </tr>
              <tr>
                <td>3.</td>
                <td>
                  Füge zu jeder Buchung die geforderten Informationen hinzu. Solltest du Felder nicht benennen können
                  schreibe "Keine Ahnung" hinein.
                </td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Sollte der Buchungsbetrag negativ sein musst du eine Rechnung hochladen.</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Wenn alle Felder einer Buchung ausgefüllt sind klicke auf "Fertig"</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>
                  Wenn der Monat abgeschlossen ist oder du zwischenspeichern willst klicke auf das Speichersymbol in der
                  rechten, oberen Ecke.
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showAnleitung = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>
    <dialogRechnung
      :visible.sync="showRechnung"
      :rechnungid="selectRechnung.id"
      @close="showRechnung = false"
    ></dialogRechnung>
  </v-container>
</template>

<script>
  import papa from "papaparse";
  export default {
    props: ["konto"],
    data() {
      return {
        artItems: [
          "Keine Angabe",
          "Rechnung Interne Veranstaltung",
          "Rechnung Externe Veranstaltung",
          "Bierrechnung",
          "Semesterbeitrag",
          "Mitgliedsbeitrag",
          "Bankgebühr",
          "Thekenmiete",
          "Spotify",
          "Pizza bestellen",
          "Deko",
          "Versand Semesterprogramm",
          "Versand Einladungen",
          "Damenprogramm",
          "Getränkeeinkauf",
        ],
        bbr: "",
        bbrGefunden: "",
        csvDatei: "",
        date: "",
        eintrage: [],
        expanded: [],
        headers: [
          { text: "Buchungstag", value: "Buchungstag" },
          { text: "Verwendungszweck", value: "Verwendungszweck" },
          { text: "Begünstigter", value: "Beguenstigter/Zahlungspflichtiger" },
          { text: "Betrag", value: "Betrag" },
          { text: "", value: "" },
        ],
        heute: new Date().toISOString().substr(0, 10),
        kasse: "",
        menu1: "",
        monat: new Date(),
        rechnungGefunden: "",
        search: "",
        selectedEintrag: {
          Buchungstag: {},
        },
        selectRechnung: [],
        showAnleitung: false,
        showImport: false,
        showKontakt: false,
        showRechnung: false,
        showUpload: false,
        file: "",
      };
    },
    computed: {
      kontobuch() {
        if (this.$store.state.kontobucher.loaded === false) {
          this.$store.dispatch("kontobucher/loadKontobucher");
        }
        if (this.$store.state.rechnungen.loaded === false) {
          this.$store.dispatch("rechnungen/loadRechnungen");
        }
        let kontobuch = this.$store.getters["kontobucher/kontobucherKasse"](this.konto);
        let ergebnis = {
          buchungen: [],
        };
        kontobuch.forEach((item) => {
          if (item.monat === new Date(this.monat).getFullYear() + "-" + parseInt(new Date(this.monat).getMonth() + 1)) {
            ergebnis = item;
          }
        });
        return ergebnis;
      },
    },
    methods: {
      buchungClick() {
        let text = this.selectedEintrag.Verwendungszweck;
        let rechnung = "";
        this.selectRechnung = "";
        try {
          rechnung = this.$store.getters["rechnungen/rechnungNummer"](text.match(/(\d{4})*-.*(\d{4})/)[0]);
          this.bbrGefunden = rechnung.bbrID;
          this.selectRechnung = rechnung;
        } catch (e) {}
        if (this.selectedEintrag.Betrag1 === undefined) {
          this.selectedEintrag.Betrag1 = this.selectedEintrag.Betrag;
          this.selectedEintrag.MwSt1 = "Keine Angabe";
        }
      },
      setAbgeschlossen() {
        if (
          this.selectedEintrag.Betreff &&
          this.selectedEintrag.Art &&
          this.selectedEintrag.Betrag1 &&
          this.selectedEintrag.MwSt1
        ) {
          this.selectedEintrag.Abgeschlossen = true;
          this.$store.dispatch("kontobucher/updateKontobuchData", this.kontobuch);
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Daten wurden gespeichert.",
          };
          if (this.file) {
            let id =
              this.konto + "-" + this.kontobuch.id + "-" + this.kontobuch.buchungen.indexOf(this.selectedEintrag);
            let selectedEintrag = this.selectedEintrag;
            let kontobuch = this.kontobuch;
            this.$firebase
              .storage()
              .ref("kontobuch/" + id)
              .put(this.file)
              .then(function (snapshot) {
                let index = kontobuch.buchungen.indexOf(selectedEintrag);
                kontobuch.buchungen[index].file = snapshot.ref.fullPath;
                this.$firebase
                  .firestore()
                  .collection("vereine")
                  .doc(this.$vars.verbindung)
                  .collection("kontobucher")
                  .doc(kontobuch.id)
                  .update(kontobuch);
                this.file = [];
                (err) => {
                  console.log(`Encountered error: ${err}`);
                };
              });
          }
        } else {
          this.$store.state.snackbar = {
            show: true,
            nachricht: "Vor Abschluss müssen alle Felder ausgefüllt sein.",
          };
        }
      },
      uploadData() {
        let monat = this.monat;
        const fileToLoad = this.csvDatei;
        const reader = new FileReader();
        let eintrage = [];
        reader.onload = (fileLoadedEvent) => {
          papa.parse(fileLoadedEvent.target.result, {
            header: true,
            encoding: "ISO-8859-1",
            complete(results) {
              results.data.forEach((item) => {
                item.Betrag = parseFloat(item.Betrag.replace(",", ".")).toFixed(2);
                let parts = item.Buchungstag.match(/(\d+)/g);
                item.Buchungstag = new Date("20" + parts[2], parts[1] - 1, parts[0]);
                if (
                  new Date(monat).getFullYear() === parseInt("20" + parts[2]) &&
                  new Date(monat).getMonth() === parseInt(parts[1] - 1)
                ) {
                  eintrage.push(item);
                }
              });
            },
            error(errors) {
              console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
        this.eintrage = eintrage;
        this.showImport = true;
        this.showUpload = false;
        this.csvDatei = "";
      },
      importData() {
        let summe = 0;
        this.eintrage.forEach((eintrag) => {
          summe += parseFloat(eintrag.Betrag);
        });
        let item = {
          buchungen: this.eintrage,
          monat: new Date(this.monat).getFullYear() + "-" + parseInt(new Date(this.monat).getMonth() + 1),
          summe: summe.toFixed(2),
          kasse: this.konto,
          geaendertAm: new Date(),
        };
        this.$store.dispatch("kontobucher/createKontobuch", item);
        this.showImport = false;
        this.showUpload = false;
      },
      deleteEintrag(item) {
        this.$store.dispatch("kontobucher/deleteKontobuchData", item.id);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// kontobuch.vue?439b48bf